import React, {Component, Fragment} from 'react';

import './infoWindow.scss';

//components
import Slider from 'react-slick';
import Loader from '../../../../components/common/loader';

//assets
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import slider_arrow from 'assets/icons/slider-arrow-purple.svg';
import {getMediaPath} from "../../../../app/functions";

class InfoWindow extends Component {

    render() {
        const {className = '', active = false} = this.props;

        let settings = {
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            rtl: false,
            arrows: true,
            nextArrow: <SliderArrow customClass="slider-next" />,
            prevArrow: <SliderArrow customClass="slider-prev" />,
            afterChange: current => this.props.arrowOnClick(current),
        };

        const isSlider = this.props.children.length > 0;


        return (
            <div className={className + ' infoWindow ' + (active ? 'active' : '')}>
                {isSlider &&
                <Fragment>
                    <Slider className='infoWindow-slider' {...settings}>
                        {this.props.children}
                    </Slider>
                    <div className='current-wrapper'>
                        <span>{this.props.current }</span>
                        <span> מתוך </span>
                        <span>{this.props.children.length}</span>
                    </div>
                </Fragment>
                }
                {!isSlider &&
                <Loader/>
                }
            </div>
        )
    }
}

function SliderArrow(props) {
    const {onClick,className} = props;
    return (
        <div className={className} onClick={onClick}>
            <img src={getMediaPath(slider_arrow)} alt=""/>
        </div>
    );
}


export default InfoWindow;
